import { Component, OnInit } from '@angular/core';
import { CASOSEXITO } from '../../interfaces/casos-exito.interface';
import { CasosExitoService } from '../../services/casos-exito.service';
import { CASO } from '../../interfaces/caso.interface';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-casos-exito',
  templateUrl: './casos-exito.component.html',
  styleUrls: ['./casos-exito.component.css']
})
export class CasosExitoComponent implements OnInit {
  // titleTxt = "casos de \n éxito"
  titleTxt = ""
  casosExito: any
  ordererCasoItems: any[] = [];

  constructor(private casosExitoService: CasosExitoService) {
  }

  ngOnInit(): void {
    this.casosExitoService.getCasosStatic().pipe(
      switchMap((resp) => {
        this.titleTxt = resp.data.titleTxt;
        return this.casosExitoService.getCasosExitoItems();
      })
    )
      .subscribe({
        next: (data: any) => {
          this.casosExito = data;
          // Test if datePublishing is null or empty and in that case, test if date is less than today
          this.casosExito = data.data.cases.rows.filter(caso => caso.status === 1 && (!caso.datePublishing || caso.datePublishing === "" || new Date(caso.datePublishing) < new Date()));
          // Sort by date
          this.ordererCasoItems = this.casosExito.sort((b, a) => new Date(a.date!).getTime() - new Date(b.date!).getTime());
        },
        error: (err) => { }
      })

  }


}
